import { LogoWrapper } from "./style";

export const Logo = () => {
  return (
    <LogoWrapper>
      <a href="/" className="logo d-flex align-items-center">
        <img src="/assets/img/logo.jpg" alt="" />
      </a>
    </LogoWrapper>
  );
};
